import * as names from './names';
import { isInWhiteList } from './utils';

const HY_LUCKY_DRAW_URL = isInWhiteList()
    ? 'https://qvideo.qq.com/tx/20488_8b91dcfb'
    : 'https://qvideo.qq.com/mixed/pc/luckydraw.html';

export default {
    [names.HY_NOBILITY]: {
        type: 'activity',
        title: '爵位',
        url: '//qvideo.qq.com/mixed/pc/nobility.html',
        width: 706,
        height: 666,
    },
    [names.HY_RELEGATION]: {
        type: 'activity',
        title: '保级卡',
        url: '//qvideo.qq.com/mixed/pc/relegation.html',
        width: 366,
        height: 506,
    },
    [names.HY_NOBILITY_RULE]: {
        type: 'activity',
        title: '爵位说明',
        url: '//qvideo.qq.com/mixed/pc/nobility-rule.html',
        width: 706,
        height: 556,
    },
    [names.HY_NOBILITY_CAR]: {
        type: 'activity',
        title: '爵位座驾',
        url: '//qvideo.qq.com/mixed/pc/nobility-car.html',
        width: 486,
        height: 506,
    },
    /**
     * 提现页，query：
     */
    [names.HY_WITHDRAW_MONEY]: {
        type: 'activity',
        title: '提现',
        url: 'https://qvideo.qq.com/mixed/pc/withdraw-money.html',
        width: 376,
        height: 240,
    },
    /**
     * 提现记录页，query：
     * type - 页面类型，withdraw:提现记录，income:主播收入明细，manage-income:会长收入明细
     */
    [names.HY_WITHDRAW_MONEY_HISTORY]: {
        type: 'activity',
        title: '提现记录',
        url: 'https://qvideo.qq.com/mixed/pc/income-list.html?type=withdraw',
        width: 376,
        height: 476,
    },
    /**
     * 收入明细页，query：
     * type - 页面类型，withdraw:提现记录，income:主播收入明细，manage-income:会长收入明细
     */
    [names.HY_INCOME_LIST]: {
        type: 'activity',
        title: '收入明细',
        url: 'https://qvideo.qq.com/mixed/pc/income-list.html?type=income',
        width: 376,
        height: 476,
    },
    [names.HY_ANCHORS_RECOMMEND_PIC]: {
        type: 'activity',
        title: '主播推荐图',
        url: 'https://qvideo.qq.com/mixed/pc/anchors-recommend-pic.html',
        width: 376,
        height: 476,
    },
    [names.HY_ANCHORS_RECOMMEND_PIC_CLIP]: {
        type: 'activity',
        title: '编辑主播推荐图',
        url:
            'https://qvideo.qq.com/mixed/pc/photo-clip.html?type=recommend-pic',
        width: 360,
        height: 480,
        pageShadow: true,
    },
    [names.HY_LUCKYDRAW]: {
        type: 'activity',
        title: '抽奖',
        url: HY_LUCKY_DRAW_URL,
        width: 880,
        height: 700,
        pageShadow: true,
    },
    [names.HY_ROOM_MODE_EXPLAIN]: {
        type: 'activity',
        title: '房间模式说明页',
        url: 'https://qvideo.qq.com/mixed/pc/room-mode-explain.html',
        width: 360,
        height: 460,
        pageShadow: true,
    },
    [names.HY_RECOMMEND_APPRAISAL]: {
        type: 'activity',
        title: '审核考核',
        url: 'https://qvideo.qq.com/mixed/pc/recommend-appraisal.html',
        width: 360,
        height: 335,
        pageShadow: true,
    },
    [names.HY_COMPLAINT]: {
        type: 'activity',
        title: '举报理由',
        url: 'https://qvideo.qq.com/mixed/pc/complaint.html',
        width: 480,
        height: 380,
        pageShadow: true,
    },
};
